module.exports = __webpack_public_path__ + "static/media/solarPannelQuestion.5ffa0c09.png";